import ChipSummary from "./ChipSummary";

export default ChipSummary;